export default "__VITE_ASSET__Cr_JxiX5__"